import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditalProcedimentoComponent } from './edital-procedimento/edital-procedimento.component';


const routes: Routes = [  
    {
      path:'', component: EditalProcedimentoComponent
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
